
  import Vue from 'vue'
  import MobileAnalyticsTable from '@/components/functions/analytics/MobileAnalyticsTable.vue'
  import EntityFiltersCard from '@/components/filters/EntityFiltersCard.vue'
  import InfoCard from '@/components/misc/InfoCard.vue'

import { extractErrorMessage } from '@/utils/Util'
import MobileAnalyticsService from '@/services/MobileAnalyticsService'

  export default Vue.extend({
    name: 'MobileAnalyticsView',

    components: {
      InfoCard,
      MobileAnalyticsTable,
      EntityFiltersCard,
    },
    data: () => ({
      logs: [] as any,
      loading: false,
      dataError: false,
      alertText: "",
      alertType: "error",
      filters: {} as any,
      filtersConfig: [
        { attribute: 'user', always: true },
        { attribute: 'timestamp', always: true }
      ],
      versions: {
        'android': undefined,
        'ios': undefined
      } as any,
      pageSize: 15,
      currentPage: 1,
      cursorHistory: [null] as (string | null)[],
      hasNextPage: false,
      tableResetKey: 0,
    }),
    created() {
      this.getLogs(null);
      this.getVersions();
    },
    watch: {
      currentTenantId() {
        this.dataError = false;
        this.filters = {};
        this.resetPagination();
        this.getLogs(null);
      }
    },
    methods: {
      onTableReload() {
        this.resetPagination();
        this.getLogs(null);
        this.getVersions();
      },
      onFiltersApply() {
        this.resetPagination();
        this.getLogs(null);
      },
      resetPagination() {
        this.currentPage = 1;
        this.cursorHistory = [null];
        this.hasNextPage = false;
        this.tableResetKey++;
      },
      onTablePageChange({ page, itemsPerPage }: any) {
        if (itemsPerPage !== this.pageSize) {
          this.pageSize = itemsPerPage;
          this.resetPagination();
          this.getLogs(null);
          return;
        }
        if (page === this.currentPage) return;
        this.currentPage = page;
        this.getLogs(this.cursorHistory[page - 1] ?? null);
      },
      getLogs(cursor: string | null) {
        this.logs = [];
        this.loading = true;
        this.dataError = false;

        const params: any = { ...this.filters, pageSize: this.pageSize };
        if (cursor) params.cursor = cursor;

        const onSuccess = ({ logs, nextCursor }: any) => {
          this.loading = false;
          this.logs = logs;
          this.hasNextPage = !!nextCursor;
          if (nextCursor && this.cursorHistory[this.currentPage] === undefined) {
            this.cursorHistory[this.currentPage] = nextCursor;
          }
        };

        if ('user' in this.filters && this.filters.user) {
          MobileAnalyticsService.getUserLogsPage(this.currentTenantId, this.filters.user, params).then(onSuccess).catch((err: any) => {
            console.log(err, err.response);
            this.loading = false;
            this.alertType = "error";
            this.alertText = 'Error loading User Mobile Analytics ' + extractErrorMessage(err);
            this.dataError = true;
          });
        } else {
          MobileAnalyticsService.getTenantLogsPage(this.currentTenantId, params).then(onSuccess).catch((err: any) => {
            console.log(err, err.response);
            this.loading = false;
            this.alertType = "error";
            this.alertText = 'Error loading Tenant Mobile Analytics ' + extractErrorMessage(err);
            this.dataError = true;
          });
        }
      },
      getVersions() {
        for(const key in this.versions) {
          MobileAnalyticsService.getLatestVersion(key).then((version: any) => {
            this.versions[key] = version.version;
          }).catch((err: any) => {
            console.log(err, err.response);
            this.alertType = "error";
            this.alertText = extractErrorMessage(err);
            this.dataError = true;
          });
        }
      },
    },
    computed: {
      currentTenantId(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
      serverItemsLength(): number {
        if (this.hasNextPage) {
          return this.currentPage * this.pageSize + 1;
        }
        return (this.currentPage - 1) * this.pageSize + this.logs.length;
      },
    }
  })
